import React, { useEffect, useRef, useState } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";

const required = (value) => {
  if (!value) {
    return <div className="invalid-feedback d-block">This field is required.</div>;
  }
};

const Login = () => {
  const form = useRef();
  const checkBtn = useRef();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    AuthService.logout();
  }, []);

  const handleLogin = (event) => {
    event.preventDefault();
    setMessage("");
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(username, password).then(
        () => {
          navigate("/home");
          window.location.reload();
        },
        (error) => {
          const responseMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
          setMessage(responseMessage);
        }
      );
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form-card">
      <div className="auth-form-card__brand">
        <span className="portal-pill portal-pill--outline">Secure sign in</span>
        <h2>Access the PayMe corporate portal</h2>
        <p>
          Use your assigned credentials to process payments, review reports, and manage
          operational workflows securely.
        </p>
      </div>

      <Form onSubmit={handleLogin} ref={form}>
        <div className="form-group mb-3">
          <label htmlFor="username">Username</label>
          <Input
            type="text"
            className="form-control"
            name="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            validations={[required]}
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="password">Password</label>
          <Input
            type="password"
            className="form-control"
            name="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            validations={[required]}
          />
        </div>

        <div className="d-grid gap-2">
          <button className="btn btn-primary auth-submit-button" disabled={loading}>
            {loading ? (
              <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
            ) : null}
            <span>{loading ? "Signing in..." : "Sign in"}</span>
          </button>
        </div>

        {message ? (
          <div className="form-group mt-3">
            <div className="alert alert-danger mb-0" role="alert">
              {message}
            </div>
          </div>
        ) : null}

        <div className="auth-form-card__footer">
          <span>Need a new account?</span>
          <Link to="/register">Register an administrator</Link>
        </div>

        <CheckButton style={{ display: "none" }} ref={checkBtn} />
      </Form>
    </div>
  );
};

export default Login;
